export default {
  "b2b.smlouvy-grid.add": "Add contract",
  "b2b.smlouvy-grid.title": "Contracts",
  "b2b.smlouvy-grid.delete-dialog.title": "Delete contract",
  "b2b.smlouvy-grid.delete-dialog.confirm":
    "Are you sure you want to delete the contract?"
};
